import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04b75f3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "asnchor"
}
const _hoisted_2 = { class: "asnchor-user" }
const _hoisted_3 = { class: "asnchor-user-left" }
const _hoisted_4 = { class: "avatar" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "nickname van-ellipsis" }
const _hoisted_7 = { class: "fsBox" }
const _hoisted_8 = { class: "b" }
const _hoisted_9 = { class: "a" }
const _hoisted_10 = { class: "asnchor-name-right" }
const _hoisted_11 = { class: "asnchor-live" }
const _hoisted_12 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return ($setup.props.roomdata)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_van_image, {
                class: "img",
                fit: "cover",
                "lazy-load": "",
                src: $setup.props.roomdata.portrait,
                alt: ""
              }, null, 8 /* PROPS */, ["src"]),
              _createVNode(_component_van_image, {
                class: "zb",
                src: $setup.roomZb,
                round: ""
              }, null, 8 /* PROPS */, ["src"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString($setup.props.roomdata.nickname), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString($setup.props.roomdata.fans_number), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('play.fensi')), 1 /* TEXT */)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createCommentVNode(" <span :style=\"{ 'background': primaryColor }\" @click=\"onChatClick(2)\">{{ $t('play.sixin') }}</span> "),
            ($setup.isStart)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  style: {"background":"#bcbcbc"},
                  onClick: $setup.enStart
                }, _toDisplayString(_ctx.$t('home.areadyfocus')), 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  style: {"background-color":"#F0082E"},
                  onClick: $setup.toStart
                }, "+ " + _toDisplayString(_ctx.$t('home.onFocus')), 1 /* TEXT */))
          ])
        ]),
        _createCommentVNode(" <div class=\"asnchor-name\">\r\n      <div class=\"asnchor-name-left\">\r\n        <div class=\"asnchor-name-left-top\">\r\n          <span>{{ props.roomdata.nickname }}</span>\r\n          <img v-lazy=\"zhubo\" alt=\"\" />\r\n        </div>\r\n        <p>房间号：{{ props.roomdata.room_id }}</p>\r\n      </div>\r\n     \r\n    </div> "),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('me.zbgg')), 1 /* TEXT */),
          _createElementVNode("div", null, [
            _createElementVNode("p", {
              innerHTML: $setup.filterHtml($setup.props.roomdata.live_trailer)
            }, null, 8 /* PROPS */, _hoisted_12)
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}